module.exports = __webpack_public_path__ + "fonts/icomoon.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/icomoon.eot
// module id = 20
// module chunks = 0